// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  envName: 'dev',

  provisionerUrl: 'https://cloud-prov-api-dev.musea2.azure.ext.gm.com',
  // provisionerUrl: 'http://localhost:3000',
  consumerUrl: 'https://maxis-consumers.apps.pcfepgstg1mi.gm.com',
  thirdPartyUrl: 'https://share.gm.com/sites/maxisfor3rdparties/SitePages/How-to-Onboard-to-Maxis-for-Dealers.aspx',
  mobileUrl: 'https://generalmotors.sharepoint.com/:b:/r/sites/MaxisSupportandOperations/Shared%20Documents/UX/Marketing/Mobile/Final-Mobile-MAM-Flyer.pdf?csf=1&web=1',
  chartsUrl: 'https://maxis-charts.pcfepgstg1mi.gm.com/',
  yammerURl: 'https://engage.cloud.microsoft/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxOTYzOTA2ODI2MjQifQ',
  awsUrl: 'https://gmsandbox.awsapps.com/start#/',
  azureUrl: 'https://portal.azure.com',
  galileoAzure: 'https://galileo.op43i.gm.com/sr-next-gen-cloud-ui/',
  clientId: '5c026c06-be87-49f7-9d76-bee3de4d015b', 
  tenantId: '6baa4eb1-106a-440b-b4f6-50134497d36d',
  provisionerApiIdentifier: 'api://cloudserve-api-test.dev.gm.com',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
